export default "__VITE_ASSET__DIT_8nc___"